<script>
  let register = true
  export let loginWithEmailPassword;
  export let loginWithGoogle;
  export let loginWithFacebook;
  export let loginAnonymously;
  export let registerWithEmailPassword;
  let error = '';
  const loginHandler = async event => {
    const { email, password } = event.target.elements;
    try {
      error = '';
      if (register)
        await registerWithEmailPassword(email.value, password.value);
      else
        await loginWithEmailPassword(email.value, password.value);
    } catch (err) {
      error = err.message;
    }
  };
</script>

<div class="w-full rounded-sm max-w-[400px] mx-auto">
  
  <form
    class="p-8 mt-10 bg-white border"
    on:submit|preventDefault={loginHandler}
  >
    <div class="mb-4">
      <label for="email">Email</label>
      <input
        class="input-field"
        id="email"
        type="email"
        placeholder="name@acme.com"
        required
      />
    </div>
    <div class="mb-6">
      <label for="password">Password</label>
      <input
        class="input-field"
        id="password"
        type="password"
        placeholder="******************"
        required
      />
    </div>
    <div class="text-red-500 py-2">{error}</div>
    {#if register}
      <div>
        <button type="submit" class="w-full py-2.5 px-2 bg-teal-700 hover:bg-teal-800 rounded-md text-white">Create account</button>
      </div>
      <div class="pt-2">Already have an account? <span class="text-teal-700 cursor-pointer" on:click={() =>{register = false}}>Log in</span></div>
    {:else}
      <div>
        <button type="submit" class="w-full py-2.5 px-2 bg-teal-700 hover:bg-teal-800 rounded-md text-white">Sign In</button>
      </div>
      <div class="pt-2">Don't have an account? <span class="text-teal-700 cursor-pointer" on:click={() => {register = true}}>Sign up</span></div>
    {/if}
    <div class="py-2">
      or
    </div>
    <div class="mt-3">
      <button
          type="button"
          class="w-full mt-3 p-0"
          on:click|preventDefault={loginWithGoogle}
        >

          <div class="flex items-center bg-white hover:bg-gray-1 text-lg text-gray-9 justify-between w-full rounded-md border">
            <img src="/google.png" class="h-12 p-2" alt="">
            <div class="flex-grow">Sign in with Google</div>
          </div>

      </button>
    </div>
    <div class="mt-2">
      <button type="button" class="flex items-center w-full py-2.5 px-2 rounded-md text-white bg-blue-800" on:click|preventDefault={loginWithFacebook}>
        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-brand-facebook text-3xl" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
          <path d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3" />
        </svg>
        <div class="flex-grow">Sign In with Facebook</div>
      </button>
    </div>
    <div class="mt-4">
      <button type="button" class="w-full bg-gray-400 hover:bg-gray-500 py-2.5 px-4 rounded-md text-white" on:click|preventDefault={loginAnonymously}>
        Stay Anonymous
      </button>
      <div class="text-xs pt-2">*NOTE using annonymous sign in will only store data as long as the session is active. Logout and using the annonymous sign in again will not retain any previous data.</div>
    </div>
  </form>
</div>

<style>
  label {
    @apply block mb-2 text-sm font-bold text-gray-700 text-left;
  }
  .input-field {
    @apply border w-full py-2 px-3 text-gray-700 mb-3;
  }
  .input-field:focus {
    @apply outline-none;
  }
  button:focus {
    @apply outline-none;
  }
</style>